import React from 'react';
import { tx } from '../utils/i18n';
import { LoomEmbed } from './LoomEmbed';
import { useLanguage } from '../contexts/LanguageContext';

const IntegrationsSection = () => {
  const { currentLanguage } = useLanguage();

  const integrations = [
    {
      id: 'ff4505e24c7845279d843d62218ede41',
      brand: 'Cirkul',
      publisher: 'shopcheck.net',
      title: 'Compliance Review',
      description: tx(currentLanguage, 'Intégration de contenu avec conformité', 'Content integration with compliance', 'Content-Integration mit Compliance')
    },
    {
      id: '59990122b06a427f87ce481b72c30779',
      brand: 'LatestBedding',
      publisher: 'milled.com',
      title: tx(currentLanguage, 'Commerce de Contenu', 'Content Commerce', 'Content-Commerce'),
      description: tx(currentLanguage, 'Intégration e-commerce dans newsletters', 'E-commerce integration in newsletters', 'E-Commerce-Integration in Newslettern')
    },
    {
      id: 'bbcd0bd7dd1f438ea7b56af9fa8feef7',
      brand: 'Prohealth',
      publisher: 'milled.com',
      title: tx(currentLanguage, 'Conformité Santé', 'Health Compliance', 'Gesundheits-Compliance'),
      description: tx(currentLanguage, 'Contenu santé et bien-être conforme', 'Compliant health and wellness content', 'Konformer Gesundheits- und Wellness-Inhalt')
    },
    {
      id: 'a3c2a24114784d178c0e0f99e9eb5a0e',
      brand: 'AttractionTickets',
      publisher: 'foroactivo.com',
      title: 'Compliance Review',
      description: tx(currentLanguage, 'Intégration dans forums communautaires', 'Integration in community forums', 'Integration in Community-Foren')
    },
    {
      id: '15e58afeda854d7b852e58898e51c2b8',
      brand: 'myrevair US',
      publisher: 'sassytownhouseliving.com',
      title: tx(currentLanguage, 'Commerce de Contenu', 'Content Commerce', 'Content-Commerce'),
      description: tx(currentLanguage, 'Intégration lifestyle et beauté', 'Lifestyle and beauty integration', 'Lifestyle- und Beauty-Integration')
    },
    {
      id: '6412421e286b435bb32a5bd4aea54cc7',
      brand: 'Backmarket (GB)',
      publisher: 'pythoncentral.io',
      title: tx(currentLanguage, 'Intégration Tech', 'Tech Integration', 'Tech-Integration'),
      description: tx(currentLanguage, 'Contenu tech natif et contextuel', 'Native and contextual tech content', 'Nativer und kontextueller Tech-Inhalt')
    },
    {
      id: 'eb2bf944fe1942d0a5be9b131c348b5a',
      brand: 'Backmarket (GB)',
      publisher: 'milled.com',
      title: tx(currentLanguage, 'Intégration Email', 'Email Integration', 'E-Mail-Integration'),
      description: tx(currentLanguage, 'Placement stratégique dans newsletters', 'Strategic placement in newsletters', 'Strategische Platzierung in Newslettern')
    },
    {
      id: 'e46a873107a14e2d8ba2ffdf33e2b2dd',
      brand: 'Back Market (FR)',
      publisher: 'listful.com',
      title: tx(currentLanguage, 'Intégration Listes', 'List Integration', 'Listen-Integration'),
      description: tx(currentLanguage, 'Placement dans listes curées', 'Placement in curated lists', 'Platzierung in kuratierten Listen')
    },
    {
      id: '0df892097029443a82e34ad93922e9d1',
      brand: 'Back Market (FR)',
      publisher: 'milled.com',
      title: 'Compliance Review',
      description: tx(currentLanguage, 'Conformité contenu commerce FR', 'FR content commerce compliance', 'FR-Content-Commerce-Compliance')
    },
    {
      id: '1f6bcccd4816457895d34cf92af91666',
      brand: 'Dreams (GB)',
      publisher: 'bestukreview.co.uk',
      title: tx(currentLanguage, 'Commerce de Contenu', 'Content Commerce', 'Content-Commerce'),
      description: tx(currentLanguage, 'Intégration dans reviews produits', 'Integration in product reviews', 'Integration in Produktbewertungen')
    }
  ];

  return (
    <section id="integrations" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-3xl lg:text-5xl font-bold text-gray-900 mb-4">
            {tx(currentLanguage, 'Nos Intégrations', 'Our Integrations', 'Unsere Integrationen')}
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            {tx(currentLanguage, 'Découvrez comment nos solutions s\'intègrent parfaitement avec vos marques préférées à travers des éditeurs de confiance.', 'Discover how our solutions integrate seamlessly with your favorite brands across trusted publishers.', 'Entdecken Sie, wie unsere Lösungen sich nahtlos mit Ihren Lieblingsmarken über vertrauenswürdige Publisher integrieren.')
            }
          </p>
        </div>

        {/* Integrations Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {integrations.map((integration, index) => (
            <div 
              key={index} 
              className="bg-white rounded-2xl p-6 hover:shadow-xl transition-shadow duration-300"
            >
              <div className="mb-4">
                <div className="text-sm text-blue-600 font-semibold mb-2">
                  {integration.brand} × {integration.publisher}
                </div>
                <h3 className="text-lg font-bold text-gray-900 mb-2">
                  {integration.title}
                </h3>
                <p className="text-gray-600 text-sm mb-4">
                  {integration.description}
                </p>
              </div>
              <div className="relative bg-gray-100 rounded-lg overflow-hidden">
                <LoomEmbed
                  id={integration.id}
                  label={`${integration.brand} × ${integration.publisher}`}
                />
              </div>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="text-center mt-12">
          <p className="text-lg text-gray-600 mb-6">
            {tx(currentLanguage, 'Intéressé par ces intégrations pour votre marque ?', 'Interested in these integrations for your brand?', 'Interessiert an diesen Integrationen für Ihre Marke?')
            }
          </p>
          <button 
            onClick={() => {
              const contactSection = document.getElementById('contact');
              if (contactSection) {
                contactSection.scrollIntoView({ behavior: 'smooth' });
              }
            }}
            className="bg-gradient-to-r from-blue-600 to-cyan-500 hover:from-blue-700 hover:to-cyan-600 text-white px-8 py-4 rounded-lg font-semibold transition-all duration-300 transform hover:scale-105"
          >
            {tx(currentLanguage, 'Contactez-nous', 'Contact Us', 'Kontaktieren Sie uns')}
          </button>
        </div>
      </div>
    </section>
  );
};

export default IntegrationsSection;
